import React, { PropTypes } from 'react';
import { Tabs, Modal, Input, Icon, Button, message, Spin } from 'antd';
import DataService from '../../../lib/DataService';
import ReactQiniuModule from '../../../../../lib/ReactQiniuModule';
import SharedTools from '../../../lib/SharedTools';

const { TextArea } = Input;

export default class CreateNotificationsComponent extends React.Component {
  constructor(props) {
    super(props);
    // set state
    this.state = {
      currentRole: props.currentRole,
      schoolId: props.schoolId,
      visibility: "请选择班级...",
      title: "",
      content: "",
      uploadedFiles: [],
      uploadingFiles: [],
      classes: [],
      confirmedVisiblity: [],
      classesModalVisible: false,
      spinning: true,
      allClassesChecked: false,
      allClassesCheckedConfirmed: false,
    };
    // bind this
    this.onTitleChange = this.onTitleChange.bind(this);
    this.onContentChange = this.onContentChange.bind(this);
    this.handleNotificationPublish = this.handleNotificationPublish.bind(this);
    this.onAllClassesChecked = this.onAllClassesChecked.bind(this);
    this.onClassChecked = this.onClassChecked.bind(this);
    this.handleVisibilityOk = this.handleVisibilityOk.bind(this);
    this.handleVisibilityCancel = this.handleVisibilityCancel.bind(this);
    this.showClassesModal = this.showClassesModal.bind(this);
    this.onFileUploadSuccess = this.onFileUploadSuccess.bind(this);
    this.onFileStartUpload = this.onFileStartUpload.bind(this);
    this.isAllUploadingFileFinished = this.isAllUploadingFileFinished.bind(this);
    this.getAvailableQuotaForUploadingFiles = this.getAvailableQuotaForUploadingFiles.bind(this);
  }

  componentDidMount(){
    DataService.getClassList({school_id: this.state.schoolId}).then(res => {
      let response = res.filter(c => !c.is_graduated && !c.is_deleted);
      // classes: grouped by grade number
      let classes = [1, 2, 3, 4, 5].map(gradeNumber => {
        return ({
          checked: true,
          gradeNumber: gradeNumber,
          classes: response.filter(c => c.grade_number == gradeNumber)
        });
      }).filter(g => g.classes.length > 0).sort((g1, g2) => g1.gradeNumber - g2.gradeNumber)

      classes.forEach(g => {
        g.visibilityClassIds = g.classes.map(c => c.id);
        g.gradeName = g.classes[0].grade_name;
        g.is_graduated = g.classes[0].is_graduated;
      })

      let grades = classes.filter((c) => !c.is_graduated);

      this.setState({
        classes: grades,
        confirmedVisiblity: classes.map(g => {return ({checked: g.checked, visibilityClassIds: g.visibilityClassIds})}),
        allClassesChecked: true,
        allClassesCheckedConfirmed: true,
        visibility: "全校",
        spinning: false
      });
    }, error => {
      console.log(error);
      message.error("加载失败，请稍后重试");
      this.setState({
        spinning: false
      });
    })
  }

  onTitleChange(e) {
    this.setState({
      title: e.currentTarget.value
    });
  }

  onContentChange(e) {
    this.setState({
      content: e.currentTarget.value
    });
  }

  handleNotificationPublish() {
    if (!this.state.title || this.state.title.length <= 0) {
      message.error('通知标题不能为空！');
      return;
    }

    if (!this.state.content || this.state.content.length <= 0) {
      message.error('通知内容不能为空！');
      return;
    }

    if (this.state.uploading) {
      message.error('请等待图片上传结束！');
      return;
    }

    let visibilityClassIds = []
    if (this.state.currentRole.associatName == "classRecord") {
      visibilityClassIds = [this.state.currentRole.associatObj.id];
    } else {
      visibilityClassIds = this.state.confirmedVisiblity.map(g => g.visibilityClassIds).reduce((a, b) => a.concat(b));
    }

    if (visibilityClassIds.length <= 0) {
      message.error('请选择可见范围');
      return;
    }

    this.setState({
      spinning: true
    });
    DataService.createNotification(this.state.title, this.state.content, JSON.stringify(this.state.uploadedFiles.map(f => f.remote_url)), JSON.stringify(visibilityClassIds)).then(response => {
      message.success("成功发布通知！");
      this.state.classes.forEach(g => {
        g.checked = true,
        g.visibilityClassIds = g.classes.map(c => c.id);
      })
      this.setState({
        title: "",
        content: "",
        uploadedFiles: [],
        uploadingFiles: [],
        visibility: "全校",
        allClassesChecked: true,
        allClassesCheckedConfirmed: true,
        confirmedVisiblity: this.state.classes.map(g => {return ({checked: g.checked, visibilityClassIds: g.visibilityClassIds})}),
        spinning: false
      })
    }, error => {
      console.log(error);
      message.error("发布通知失败，请稍后重试");
      this.setState({
        spinning: false
      })
    })
  }

  onAllClassesChecked() {
    if (this.state.allClassesChecked) {
      this.state.classes.forEach(g => {
        g.visibilityClassIds = [];
        g.checked = false;
      })
      this.setState({
        classes: this.state.classes,
        allClassesChecked: false
      })
    } else {
      this.state.classes.forEach(g => {
        g.visibilityClassIds = g.classes.map(c => c.id)
        g.checked = true;
      })
      this.setState({
        classes: this.state.classes,
        allClassesChecked: true
      })
    }
  }

  onClassChecked(gradeNumber, classId) {
    let grade = this.state.classes.find(c => c.gradeNumber == gradeNumber)
    if (!grade) {
      return;
    }

    if (classId) {
      let index = grade.visibilityClassIds.indexOf(classId);
      if (index >= 0) {
        grade.visibilityClassIds.splice(index, 1);
      } else {
        grade.visibilityClassIds.push(classId);
      }
    } else {
      if (grade.checked) {
        grade.visibilityClassIds = [];
      } else {
        grade.visibilityClassIds = grade.classes.map(c => c.id);
      }
    }

    grade.checked = grade.visibilityClassIds.length >= grade.classes.length;

    this.setState({
      classes: this.state.classes,
      allClassesChecked: this.state.classes.filter(g => g.checked).length == this.state.classes.length
    })
  }

  handleVisibilityOk() {
    let confirmedVisiblity = this.state.classes.map(g => {return ({checked: g.checked, visibilityClassIds: g.visibilityClassIds})});

    let visibility = ""

    if (this.state.allClassesChecked) {
      visibility = "全校";
    } else {
      visibility = this.state.classes.filter(g => g.visibilityClassIds.length > 0).map(g => g.gradeName).join("、");
    }

    if (visibility == "") {
      visibility = "请选择班级...";
    }

    this.setState({
      visibility: visibility,
      classesModalVisible: false,
      classes: this.state.classes,
      confirmedVisiblity: confirmedVisiblity,
      allClassesCheckedConfirmed: this.state.allClassesChecked,
    })
  }

  handleVisibilityCancel() {
    this.state.classes.forEach((g, index) => {
      g.checked = this.state.confirmedVisiblity[index].checked;
      g.visibilityClassIds = this.state.confirmedVisiblity[index].visibilityClassIds;
    });
    this.setState({
      classesModalVisible: false,
      classes: this.state.classes,
      allClassesChecked: this.state.allClassesCheckedConfirmed,
    });
  }

  showClassesModal() {
    this.setState({
      classesModalVisible: true
    })
  }

  _checkCircleIcon(checked, onClick) {
    if (checked) {
      return (<Icon className={checked ? "checked" : ""} onClick={onClick} type="check-circle" />);
    } else {
      return (<Icon className={checked ? "checked" : ""} onClick={onClick} type="check-circle-o" />);
    }
  }

  _selectClassesModal() {
    return (
      <Modal wrapClassName="notifications-select-classes-modal" visible={this.state.classesModalVisible} onCancel={this.handleVisibilityCancel} maskClosable={false} footer={[
        <Button className="confirm-visibility-button" type="primary" key="confirm" onClick={this.handleVisibilityOk}>确认班级</Button>
      ]}>
        <div className="selected-classes-count">已选{this.state.classes.map(g => g.visibilityClassIds.length).reduce((a, b) => a + b, 0)}个班级</div>
        <div className={"all-classes-check-box" + (this.state.allClassesChecked ? " checked" : "")}>
          {this._checkCircleIcon(this.state.allClassesChecked, this.onAllClassesChecked)}
          <div className="all-classes-label">全校</div>
        </div>
        {this.state.classes.map(grade =>
          <div className="grade-classes-check-box" key={grade.gradeNumber} >
            {this._checkCircleIcon(grade.checked, this.onClassChecked.bind(this, grade.gradeNumber, undefined))}
            <div className="grade-name">{grade.gradeName}</div>
            <div className="grade-classes-container">
              {grade.classes.map(c => <div className={"class-name" + (grade.visibilityClassIds.indexOf(c.id) >= 0 ? " checked" : "")} key={c.id} onClick={this.onClassChecked.bind(this, grade.gradeNumber, c.id)}>{c.name}</div>)}
            </div>
          </div>
        )}
      </Modal>
    )
  }

  toolUpdateFilesList(type, newFilesList) {
    if (type == 'uploaded')
      this.setState({
        uploadedFiles: newFilesList
      });
    else if (type == 'uploading')
      this.setState({
        uploadingFiles: newFilesList
      });

    return true;
  }

  getAvailableQuotaForUploadingFiles() {
    return 9 - this.state.uploadedFiles.length - this.state.uploadingFiles.length;
  }

  onFileStartUpload(newFileKey) {
    // check quota limit
    if (this.getAvailableQuotaForUploadingFiles() <= 0)
        return false;
    // check file duplicated
    let exist1 = undefined != this.state.uploadedFiles.find((uploadedFile) => uploadedFile.key.split("#")[0] == newFileKey );
    let exist2 = undefined != this.state.uploadingFiles.find((uploadingFile) => uploadingFile.key == newFileKey );
    if (exist1 || exist2)
        return false;

    // update uploadingFiles
    let newFiles = SharedTools.cloneObject(this.state.uploadingFiles);
    newFiles.push(newFileKey);

    return this.toolUpdateFilesList('uploading', newFiles);
  }

  onFileUploadSuccess(newFileKey, fileName, fileSize, remoteUrl, info) {
    let newFiles = SharedTools.cloneObject(this.state.uploadedFiles);
    newFiles.push({
        key: newFileKey + "#" + Date.now(),
        name: fileName,
        size: fileSize,
        remote_url: remoteUrl,
        info: info
    });
    // set state: uploaded
    this.toolUpdateFilesList('uploaded', newFiles);

    // set state: uploading
    newFiles = this.state.uploadingFiles.filter((uploadingFileKey) => uploadingFileKey != newFileKey );
    this.toolUpdateFilesList('uploading', newFiles);
  }

  isAllUploadingFileFinished() {
    return this.state.uploadingFiles.length <= 0;
  }

  removeUploadedFile(e) {
    e.stopPropagation();
    let index = this.state.uploadedFiles.findIndex(f => f.key == e.currentTarget.dataset.filekey)
    if (index >= 0) {
      this.state.uploadedFiles.splice(index, 1);
      this.toolUpdateFilesList('uploaded', this.state.uploadedFiles);
    }
  }

  _uploadPhotos() {
    return(
      <div className="upload-photos-container">
        {this.state.uploadedFiles.map(file =>
          <div className="uploaded photo" key={file.key}>
            <img src={file.remote_url + "?imageView2/1/w/100"} />
            <div className="file-remove" data-filekey={file.key} onClick={this.removeUploadedFile.bind(this)}><Icon type="close" /></div>
          </div>
        )}

        {this.state.uploadingFiles.map(file =>
          <div className="uploading photo" key={file.key}>
            <Spin wrapperClassName="uploading-spin">
              <div className="uploading-holder"></div>
            </Spin>
          </div>
        )}

        {this.getAvailableQuotaForUploadingFiles() > 0 && <div className="uploading-module-container">
          <ReactQiniuModule
              className="uploading-module"
              onSuccess={this.onFileUploadSuccess}
              onStartPermit={this.onFileStartUpload}
              isAllFinish={this.isAllUploadingFileFinished}
              getUploadQuota={this.getAvailableQuotaForUploadingFiles}
              allowUploadFileTypes={ReactQiniuModule.getFileCategories.IMAGES}
              allowUploadFileSize={10} >
              <div className="uploading-content"><div className="tip">+ 添加照片</div></div>
          </ReactQiniuModule>
        </div>}
      </div>
    )
  }

  render() {
    return (
      <div className="create-notification"><Spin spinning={this.state.spinning}>
        <div className="create-notification-area">
          <label className="notification-title-label">通知主题</label>
          <Input className="notification-title" value={this.state.title} onChange={this.onTitleChange} placeholder="通知主题" />
          <TextArea className="notification-content" value={this.state.content} onChange={this.onContentChange} placeholder="通知文字" rows={10}/>
          {this._uploadPhotos()}
          {this.state.currentRole.associatName != "classRecord" && <div className="line"></div>}
          {this.state.currentRole.associatName != "classRecord" && <div className="visibility-container">
            <span>可见范围：</span>
            <Input className="visibility" value={this.state.visibility} onClick={this.showClassesModal} />
            <span>已选{this.state.confirmedVisiblity.map(g => g.visibilityClassIds.length).reduce((a, b) => a + b, 0)}个班级</span>
          </div>}
        </div>
        <Button className="publish-button" type="primary" onClick={this.handleNotificationPublish} disabled={this.state.currentRole && this.state.currentRole.associatObj.is_graduated}>发布</Button>
        {(this.state.currentRole && this.state.currentRole.associatObj.is_graduated) ? <div style={{ color: 'red', margin: '10px 0'}}>班级已毕业 无法发布新通知</div> : ''}
        {this.state.currentRole.associatName != "classRecord" && this._selectClassesModal()}
      </Spin></div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/classinfo/notificationComponents/createNotificationsComponent.jsx